import './about.scss';
import React from 'react';
import SEO from '../../components/seo/SEO';
import InfoText from '../../components/info-text/Infotext';

export default function About() {
  return (
    <div className="about">
      <SEO title="Om oss - Sportbytarboden | Din mötesplats för begagnad sportutrustning" />

      <InfoText
        heading={'Om Sportbytarboden'}
        description={
          'Sportbytarboden.se grundades hösten 2009. Sedan dess har över 30.000 kunder använt vår förmedlingstjänst.'
        }
      ></InfoText>
      <div className="about-container section-container">
        <p>
          Sportbytarboden grundades 2009 och drivs sedan 2023 av oss, Enzo och
          Calle. Vi är två unga entreprenörer som brinner för sport och
          hållbarhet. Med lång erfarenhet inom olika idrotter, och en stark
          bakgrund inom skidåkning, har vi tagit över butiken och
          vidareutvecklat konceptet för att skapa en plattform där både nya och
          begagnade sportprodukter kan byta ägare på ett enkelt och hållbart
          sätt.
        </p>
        <p>
          <strong>Vår vision</strong> är att göra sportutrustning mer
          tillgänglig och hållbar genom återanvändning. Vi vill att fler ska
          kunna köpa bra utrustning till rätt pris och samtidigt bidra till ett
          mer hållbart samhälle.
        </p>
        <h2>Varför välja oss?</h2>
        <ul>
          <li>Låg kommission på sålda varor</li>
          <li>Snabb och automatiserad utbetalning</li>
          <li>
            Enklare än att sälja genom internetbaserade plattformar – och
            definitivt enklare att köpa!
          </li>
        </ul>
        <p>
          Har du frågor eller funderingar?{' '}
          <a href="butik#kontakt">Tveka inte att kontakta oss</a>
        </p>
      </div>
    </div>
  );
}
